<!--Footer-->
<template>
    <div>
 <!--Footer-->
    <footer class="footer">
        <b-container >
            <b-row>
                <b-col md="4">
                    <h4>TimelessLeather</h4>
                    <p>Discover the finest leather products crafted with precision and care. Our collection offers timeless elegance and durability for those who appreciate quality.</p>
                </b-col>

                <b-col md="4">
                    <h4>Quick Links</h4>
                    <ul class="footer-links">
                        <li><router-link to="/">Home</router-link></li>
                        <li><router-link to="/leather">Leather</router-link></li>
                        <li><router-link to="/about">About Us</router-link></li>
                        <li><router-link to="/contact">Contact Us</router-link></li>
                    </ul>
                </b-col>

                <b-col md="4">
                    <h4>Contact Us</h4>
                    <p>123 Owode  Onirin, Suite 100<br>Ikorodu, Lagos State<br>Phone: 08033948393 <br>Email: timelessleather@gmail.com</p>
                </b-col>
 </b-row>
 <hr>
 <p class="copyright">&copy; 2026 TimelessLeather. All rights reserved.</p>
        </b-container>
    </footer>


  </div>
  </template>

<script>
    export default {
    }

</script>

<style scoped>
.footer {
    border-top: 3px solid #b65f4a;
    background-color: #303030;
    color: #f5efe6;
    padding: 40px 0;
}

.footer h4,
.footer h5 {
    color: #b65f4a;
    margin-bottom: 20px;
}

.footer p {
    color: #f5efe6;
    margin-bottom: 10px;
}

.footer ul {
    list-style: none;
    padding: 0;
}

.footer ul li {
    color: #f5efe6;
    text-decoration: none;
    margin-bottom: 10px;
}

.footer ul li a {
    color: #f5efe6;
    text-decoration: none;
}

.footer ul li a:hover {
    color: #b65f4a;
}

.footer hr {
    border-color: #555555;
    margin-top: 30px;
}

.footer .copyright {
    text-align: center;
    margin-bottom: 0px;
    font-size: 14px;
}

@media (max-width: 768px) {

  footer {
    padding: 35px 25px;
    text-align: center;
  }

  .footer-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 25px;
  }

  .footer-section {
    width: 100%;
  }

  .footer-section h3 {
    font-size: 20px;
    margin-bottom: 10px;
  }

  .footer-section p {
    font-size: 14px;
    line-height: 1.6;
  }

  .footer-links {
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
  }

}


/* SMALL PHONES */

@media (max-width: 480px) {

  footer {
    padding: 30px 15px;
  }

  .footer-container {
    gap: 20px;
  }

  .footer-section h3 {
    font-size: 18px;
  }

  .footer-section p {
    font-size: 13px;
  }

}
</style>
